import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { yodaRulesAdminAccessControl } from '../access-control/yodaRulesAdminAccess.configuration'

const YodaRulesApprovalRequestShowPage = lazy(
  () => import('../pages/approval-request/show/YodaRulesApprovalRequestShowPage')
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const yodaRulesAdminRouter = (
  <DomainRoute route="app-admin-yoda-rules" accessControl={yodaRulesAdminAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-yoda-rules-approval-request/show"
        component={YodaRulesApprovalRequestShowPage}
      />
      {/* @hygen:inject router-route 
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
